import watermark$ from './watermark';
import thumbnailGenerator from '../thumbnailGenerator';
import createServiceObservables from './createServiceObservable';

const observables = createServiceObservables(
    'smallThumbs',
    watermark$,
    async (watermark) => ({
        smallThumb: await thumbnailGenerator.generate(
            watermark.watermarked,
            watermark.params.smallThumbSize,
            watermark.photo.signal,
        ),
    }),
    1,
);
const smallThumbErrors$ = observables.errorsOnly$;
const smallThumbs$ = observables.withoutErrors$;

export { smallThumbErrors$ };
export default smallThumbs$;
